import { Link } from 'react-router-dom';
import { SELLER, SellerContacts } from './sellerInfo';

export default function Delivery() {
  const s = SELLER;

  return (
    <div className="container page" style={{ textAlign: 'left' }}>
      <h1>Доставка и возврат</h1>

      <SellerContacts showTitle />

      <section>
        <h2>1. Доставка</h2>
        <ol>
          <li>
            Доставка осуществляется по адресу, указанному Покупателем при оформлении заказа.
          </li>
          <li>
            Стоимость и срок доставки зависят от региона, выбранного способа доставки, веса/габаритов
            товара и указываются при оформлении заказа либо сообщаются Покупателю при подтверждении.
          </li>
          <li>
            Если доставка осуществляется транспортной компанией / курьерской службой, Покупателю может
            быть предоставлен номер отслеживания.
          </li>
          <li>
            При получении товара Покупатель обязан проверить упаковку, комплектность и отсутствие
            видимых повреждений. При обнаружении повреждений рекомендуется зафиксировать их
            (фото / видео) и указать замечания в документах перевозчика.
          </li>
          <li>
            Товар считается переданным в момент его вручения Покупателю либо уполномоченному лицу.
          </li>
        </ol>
      </section>

      <section>
        <h2>2. Самовывоз</h2>
        <p>
          Если на сайте доступен самовывоз, адрес пункта выдачи, график и срок хранения указываются
          при оформлении заказа (в настройках магазина / подсказке самовывоза). Точное время выдачи
          может уточняться менеджером после оплаты заказа.
        </p>
        <p>
          Актуальный адрес и режим работы Продавца: {s.address}, {s.hours}. Телефон:{' '}
          <a href={`tel:${s.phoneTel}`}>{s.phoneDisplay}</a>.
        </p>
      </section>

      <section>
        <h2>3. Отказ от товара</h2>
        <ol>
          <li>Покупатель вправе отказаться от товара в любое время до его передачи.</li>
          <li>
            После передачи товара Покупатель вправе отказаться от товара надлежащего качества в
            течение 7 дней. Если при доставке не была предоставлена письменная информация о порядке
            и сроках возврата, срок отказа может составлять до 3 месяцев (ст. 26.1 Закона РФ «О
            защите прав потребителей»).
          </li>
          <li>
            Письменная памятка о возврате:{' '}
            <Link to="/return-memo">открыть и распечатать</Link>.
          </li>
        </ol>
      </section>

      <section>
        <h2>4. Возврат товара надлежащего качества</h2>
        <ol>
          <li>
            Возврат возможен при сохранении товарного вида, потребительских свойств, упаковки (при
            наличии), а также подтверждения покупки у Продавца (допускаются иные доказательства при
            отсутствии чека).
          </li>
          <li>
            Расходы по обратной доставке товара надлежащего качества, как правило, несет Покупатель,
            если иное не предусмотрено законом или условиями конкретной акции / доставки.
          </li>
          <li>
            Денежные средства возвращаются в сроки, установленные законодательством, за вычетом
            расходов Продавца на доставку от Покупателя возвращенного товара (в случаях,
            предусмотренных законом).
          </li>
          <li>
            Товары с индивидуально‑определенными свойствами, изготовленные / подобранные под заказ,
            возврату надлежащего качества не подлежат.
          </li>
        </ol>
      </section>

      <section>
        <h2>5. Возврат товара ненадлежащего качества</h2>
        <ol>
          <li>
            В случае обнаружения недостатков товара Покупатель вправе предъявить требования,
            предусмотренные законом (ремонт, замена, соразмерное уменьшение цены, возврат денежных
            средств).
          </li>
          <li>Продавец вправе провести проверку качества товара и/или экспертизу.</li>
          <li>
            Для обращения по браку / гарантии напишите на{' '}
            <a href={`mailto:${s.email}`}>{s.email}</a> и приложите описание проблемы, фото / видео,
            номер заказа и контакты.
          </li>
        </ol>
      </section>

      <section>
        <h2>6. Как оформить возврат</h2>
        <ol>
          <li>
            Отправьте запрос на e‑mail: <a href={`mailto:${s.email}`}>{s.email}</a> с темой
            «Возврат».
          </li>
          <li>
            Укажите: ФИО, телефон, номер заказа, наименование товара, причину возврата, способ
            возврата денежных средств.
          </li>
          <li>Дождитесь подтверждения от Продавца и инструкций по передаче товара.</li>
        </ol>
        <p>
          Полный текст памятки: <Link to="/return-memo">/return-memo</Link>. Публичная оферта:{' '}
          <Link to="/oferta">/oferta</Link>.
        </p>
      </section>

      <p style={{ opacity: 0.8, marginTop: 24 }}>
        © {new Date().getFullYear()} {s.name}. Последнее обновление: {s.updatedAt}
      </p>
    </div>
  );
}
